export enum UserActionType {
    Login = 'Login',
    Logout = 'Logout',
    UploadData = 'UploadData',
    SetCurrentContext = 'SetCurrentContext',
    ChangeConsumption = 'ChangeConsumption',
    ChangeConsumption_PreferredTime = 'ChangeConsumption_PreferredTime',
    WindowOpen = 'WindowOpen'
}
